import React, { Dispatch, SetStateAction } from 'react'
import styled from 'styled-components'
import { withFormik } from 'formik'
import type { FormikProps } from 'formik'
import * as Yup from 'yup'
import { SignUpFormValues } from '../../store/userSlice'
import { ApiResult, LoadingStatus } from '../../models/Enums'
import WaitAnimation from '../Common/Wait'
import { useAppSelector } from '../../store'

interface MyFormProps {
  initialUserid?: string
  initialUsername?: string
  initialEmail?: string
  initialPassword?: string
  initialPassword2?: string
  initialGroup?: string
  onSignUp: (values: SignUpFormValues) => void
}

const InnerForm = (props: FormikProps<SignUpFormValues>) => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
  } = props

  const sigunupStatus = useAppSelector((state) => state.user.signupStatus)
  const apiResult = useAppSelector((state) => state.user.apiResult)

  return (
    <Container>
      <form onSubmit={handleSubmit}>
        <h1>회원가입</h1>
        <input
          width={50}
          type="text"
          name="userid"
          placeholder="아이디"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.userid}
        />
        {touched.userid && errors.userid ? (
          <ErrorMessage>{errors.userid}</ErrorMessage>
        ) : null}
        <input
          width={50}
          type="text"
          name="username"
          placeholder="사용자이름"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.username}
        />
        {touched.username && errors.username ? (
          <ErrorMessage>{errors.username}</ErrorMessage>
        ) : null}

        <input
          width={50}
          type="email"
          name="email"
          placeholder="E-mail 주소"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.email}
        />
        {touched.email && errors.email ? (
          <ErrorMessage>{errors.email}</ErrorMessage>
        ) : null}

        <input
          width={50}
          type="password"
          name="password"
          placeholder="비밀번호"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.password}
        />
        {touched.password && errors.password ? (
          <ErrorMessage>{errors.password}</ErrorMessage>
        ) : null}

        <input
          width={50}
          type="password"
          name="password2"
          placeholder="비밀번호 확인"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.password2}
        />
        {touched.password2 && errors.password2 ? (
          <ErrorMessage>{errors.password2}</ErrorMessage>
        ) : null}

        <input
          width={50}
          name="group"
          placeholder="소속"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.group}
        />
        {touched.group && errors.group ? (
          <ErrorMessage>{errors.group}</ErrorMessage>
        ) : null}

        <button
          type="submit"
          disabled={
            isSubmitting ||
            !!(errors.userid && touched.userid) ||
            !!(errors.username && touched.username) ||
            !!(errors.email && touched.email) ||
            !!(errors.password && touched.password) ||
            !!(errors.password2 && touched.password2) ||
            !!(errors.group && touched.group)
          }
        >
          {sigunupStatus == LoadingStatus.PENDING && (
            <WaitAnimation left="100px" top="4px" />
          )}
          가 입
        </button>

        {apiResult === ApiResult.ALREADY_EXIST && (
          <div>이미 존재하는 아이디입니다</div>
        )}
      </form>
    </Container>
  )
}

const SignUpForm = withFormik<MyFormProps, SignUpFormValues>({
  mapPropsToValues: (props) => ({
    userid: props.initialUserid || '',
    username: props.initialUsername || '',
    email: props.initialEmail || '',
    password: props.initialPassword || '',
    password2: props.initialPassword2 || '',
    group: props.initialGroup || '',
  }),

  validationSchema: Yup.object().shape({
    userid: Yup.string()
      .min(2, '사용자 아이디는 2글자이상 20글자 이하로 입력하세요')
      .max(20, '사용자 아이디는 2글자이상 20글자 이하로 입력하세요')
      .required('사용자 아이디를 입력하세요'),
    username: Yup.string()
      .min(2, '사용자 이름은 2글자이상 10글자 이하로 입력하세요')
      .max(10, '사용자 이름은 2글자이상 10글자 이하로 입력하세요')
      .required('사용자 이름을 입력하세요'),
    email: Yup.string()
      .email('E-mail 형식이 맞지 않습니다')
      .required('Email을 입릭하세요'),
    password: Yup.string().required('비밀번호를 입력하세요'),
    password2: Yup.string()
      .oneOf([Yup.ref('password')], '비밀번호가 일치하지 않습니다')
      .required('비밀번호를 입력하세요'),
    group: Yup.string().required('소속을 입력하세요'),
  }),

  handleSubmit(
    values: SignUpFormValues,
    { props, setSubmitting, setErrors, submitForm }
  ) {
    props.onSignUp(values)
    setSubmitting(false)
  },
})(InnerForm)

const Container = styled.div`
  width: 20rem;

  h1 {
    margin-bottom: 20px;
    font-size: 1.5rem;
    text-align: center;
  }

  input {
    width: 100%;
    padding: 12px;
    box-sizing: border-box;
    margin-bottom: 5px;
    border: 1px solid #ccc;
  }

  button {
    width: 100%;
    padding: 12px;
    margin-top: 10px;
    border: none;
    background-color: orange;
    position: relative;
  }
`

const ErrorMessage = styled.div`
  color: #5c5cff;
  font-size: 0.9rem;
  padding-bottom: 10px;
`

export default SignUpForm
